import type { Snippet } from 'svelte';
import type { Action } from 'svelte/action';
import type { Spacing, ResponseSpacing } from '@athena-lib/spacing';
import {
  type Size,
  type ResponsiveClasses,
  getResponsiveClasses,
  type ResponsiveSize,
} from '@athena-lib/responsive-utils';
import type { SvelteHTMLElements } from 'svelte/elements';

export type StackDividers = 'default' | 'strong';

export type { Spacing, ResponseSpacing };

export type StackProps = {
  class?: string;
  space?: Spacing | ResponseSpacing;
  center?: boolean;
  children: Snippet;
  action?: Action<HTMLDivElement, NonNullable<unknown>>;
  actionArg?: NonNullable<unknown>;
  dividers?: StackDividers;
  dividerAboveAndBelow?: boolean;
} & SvelteHTMLElements['div'];

export type StackItemProps = {
  class?: string;
  children: Snippet;
  action?: Action<HTMLDivElement, NonNullable<unknown>>;
  actionArg?: NonNullable<unknown>;
};

export type StackContext = {
  dividers: () => StackDividers | undefined;
  renderedItems: number;
};

export function getGapClasses(size: Size | ResponsiveSize | undefined) {
  return getResponsiveClasses(size, gapClasses);
}

const gapClasses: ResponsiveClasses<Size> = {
  default: {
    small: 'gap-small',
    medium: 'gap-medium',
    gutter: 'gap-gutter',
    large: 'gap-large',
    xlarge: 'gap-xlarge',
    xxlarge: 'gap-xxlarge',
  },

  md: {
    small: 'md:gap-small',
    medium: 'md:gap-medium',
    gutter: 'md:gap-gutter',
    large: 'md:gap-large',
    xlarge: 'md:gap-xlarge',
    xxlarge: 'md:gap-xxlarge',
  },

  lg: {
    small: 'lg:gap-small',
    medium: 'lg:gap-medium',
    gutter: 'lg:gap-gutter',
    large: 'lg:gap-large',
    xlarge: 'lg:gap-xlarge',
    xxlarge: 'lg:gap-xxlarge',
  },
};
